import * as go from 'gojs';
import { TEXT_NODE_PANEL, TEXT_NODE_SHAPE, TEXT_NODE_TEXT_BLOCK } from '../common/config/common-part-names';
import { CustomTextEditor } from '../common/parts/text-editor';
import {
  angleBinding,
  editableBinding,
  locationBinding,
  lockedBindings,
  shadowBindings,
  textAlignmentBinding,
  textBinding,
  textColorBinding,
  textFontBinding,
  textHighlightColorBinding,
  zOrderBindings,
} from '../common/utils/bindings';
import { realPorts, virtualPorts } from './../common/parts/port';

const $ = go.GraphObject.make;

const movable = true;
const rotatable = true;

export const textNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Spot,
    {
      isShadowed: true,
      isLayoutPositioned: false,
      locationSpot: go.Spot.TopLeft,
      toolTip: null,
      rotationSpot: go.Spot.Center,
      selectionObjectName: TEXT_NODE_PANEL,
      locationObjectName: TEXT_NODE_PANEL,
      resizeObjectName: TEXT_NODE_PANEL,
      movable,
      rotatable,
    },
    $(
      go.Panel,
      go.Panel.Auto,
      {
        name: TEXT_NODE_PANEL,
      },
      highlightShape(),
      textBlock(),
    ),
    locationBinding(),
    angleBinding(),
    ...lockedBindings({ movable, rotatable }),
    ...shadowBindings(),
    ...zOrderBindings(),
    ...virtualPorts(),
    ...realPorts(),
  );

const highlightShape = () =>
  $(
    go.Shape,
    {
      name: TEXT_NODE_SHAPE,
      shadowVisible: false,
      stroke: null,
    },
    textHighlightColorBinding(),
  );

const textBlock = () =>
  $(
    go.TextBlock,
    {
      name: TEXT_NODE_TEXT_BLOCK,
      editable: true,
      isMultiline: true,
      margin: 3,
      shadowVisible: true,
      textEditor: $(CustomTextEditor, {
        flexibleWidth: true,
      }),
    },
    textBinding(),
    textAlignmentBinding(),
    textFontBinding(),
    editableBinding(),
    textColorBinding(),
  );
